import { createQueryKeys } from '@lukemorales/query-key-factory';

export const urls = createQueryKeys('urls', {
  choices: null,
  retrieve: (urlId: string) => [urlId],
  update: (urlId: string) => [urlId],
  delete: (urlId: string) => [urlId],
});
